import Icon from '../components/Icon.vue'

Icon.register({
  'money-check': {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M0 448v-320h640v320c0 17.7-14.3 32-32 32h-576c-17.7 0-32-14.3-32-32zM448 240v32c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16h-96c-8.8 0-16 7.2-16 16zM448 360v16c0 4.4 3.6 8 8 8h112c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8h-112c-4.4 0-8 3.6-8 8zM64 264v16c0 4.4 3.6 8 8 8h304c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8h-304c-4.4 0-8 3.6-8 8zM64 360v16c0 4.4 3.6 8 8 8h176c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8h-176c-4.4 0-8 3.6-8 8zM624 32c8.8 0 16 7.2 16 16v48h-640v-48c0-8.8 7.2-16 16-16h608z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/money-check.js
// module id = 1580
// module chunks = 0